"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supabaseClient = exports.SupabaseClient = void 0;
var supabase_js_1 = require("@supabase/supabase-js");
var supabase_js_2 = require("@supabase/supabase-js");
Object.defineProperty(exports, "SupabaseClient", { enumerable: true, get: function () { return supabase_js_2.SupabaseClient; } });
var getClientWithEnvCheck = function () {
    if (!process.env.NEXT_PUBLIC_SUPABASE_URL ||
        !process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY) {
        throw new Error('NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY env variables are required!');
    }
    return (0, supabase_js_1.createClient)(process.env.NEXT_PUBLIC_SUPABASE_URL, process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY, { autoRefreshToken: false, persistSession: false });
};
exports.supabaseClient = getClientWithEnvCheck();
//# sourceMappingURL=initSupabase.js.map